module.exports = __webpack_public_path__ + "img/close.bf2628e4.png";